(() => {
  if (window.__customNuancierGafBridgeBooted) return;
  window.__customNuancierGafBridgeBooted = true;

  const GAF_FIELD_SELECTOR = 'input[name="attributes[Custom-Attribute-2]"]';
  const CART_URL = `${window.Shopify?.routes?.root || '/'}cart.js`;
  let currentSummary = '';
  let refreshTimer = null;

  const clean = (value) => String(value || '').trim();

  const getProperty = (properties, key) => {
    if (!properties) return '';
    if (Array.isArray(properties)) {
      const entry = properties.find((property) => property?.name === key);
      return clean(entry?.value);
    }
    return clean(properties[key]);
  };

  const buildSummary = (cart) => {
    const tintedItems = (cart?.items || []).flatMap((item) => {
      const tint = getProperty(item.properties, 'Teinte');
      if (!tint) return [];

      const chart = getProperty(item.properties, 'Nuancier');
      const title = clean(item.product_title || item.title || 'Produit');
      const variant = clean(item.variant_title);
      const quantity = Number(item.quantity || 1);
      const tintLabel = chart ? `${tint} (${chart})` : tint;
      const productLabel = variant ? `${title} — ${variant}` : title;

      return [`${productLabel} — Teinte ${tintLabel} — Qté ${quantity}`];
    });

    return tintedItems.join(' | ');
  };

  const applySummary = () => {
    document.querySelectorAll(GAF_FIELD_SELECTOR).forEach((field) => {
      if (field.value !== currentSummary) field.value = currentSummary;
    });
  };

  const refresh = async () => {
    try {
      const response = await fetch(CART_URL, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      currentSummary = buildSummary(await response.json());
      applySummary();
    } catch (_) {
      // The GAF bridge must never block the cart or checkout flow.
    }
  };

  const scheduleRefresh = (delay = 80) => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay);
  };

  const boot = () => {
    scheduleRefresh(0);

    document.addEventListener('cnc_update_cart_attr', () => scheduleRefresh(0));
    document.addEventListener('cart:change', () => scheduleRefresh(0));
    document.addEventListener('change', (event) => {
      if (event.target?.closest?.('form[action*="/cart"]')) scheduleRefresh(0);
    });

    document.addEventListener('submit', (event) => {
      if (event.target?.querySelector?.(GAF_FIELD_SELECTOR)) applySummary();
    }, true);

    const observer = new MutationObserver(() => applySummary());
    observer.observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('pageshow', () => scheduleRefresh(0));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
